import { render, staticRenderFns } from "./FactoringDashboard.vue?vue&type=template&id=18bc284d"
import script from "./FactoringDashboard.vue?vue&type=script&lang=js"
export * from "./FactoringDashboard.vue?vue&type=script&lang=js"
import style0 from "./FactoringDashboard.vue?vue&type=style&index=0&id=18bc284d&prod&scooped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports